import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class ProbeIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 115.55 300">
                <path
                    d="M88.56 193.34V5.92A5.92 5.92 0 0 0 82.64 0H32.92A5.92 5.92 0 0 0 27 5.92v187.42a57.78 57.78 0 1 0 61.55 0zm-23.88-143h8.35v8.35h-8.35a4.18 4.18 0 0 1 0-8.35zm0 20.22h8.35V79h-8.35a4.18 4.18 0 0 1 0-8.35zm-9.64 20.22h18v8.35h-18a4.18 4.18 0 0 1 0-8.35zm.5 193a41.1 41.1 0 0 1-13.66-78.92v-66.34a5.94 5.94 0 0 1 5.94-5.94h19.96a5.94 5.94 0 0 1 5.94 5.94v66.42a41.1 41.1 0 0 1-18.16 78.92z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(ProbeIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/ProbeIcon.js